import type { JsonDataItem } from '../types';
import type { VisibilityCondition } from './visibility-condition.interfaces';
import { VisibilityConditionBase } from './visibility-condition-base';

export class RecordLinkVisibilityCondition extends VisibilityConditionBase {
  constructor(fieldCondition: VisibilityCondition) {
    super(fieldCondition);
  }

  public runVisibilityCondition(currentData: JsonDataItem): boolean {
    if (currentData.requireStepVisibilityCheck) {
      const stepToVisibility =
        currentData.stepVisibilityRecordLinkConditionResult as
          | Record<string, boolean>
          | undefined;
      const stepId = this.fieldCondition.stepId?.toString();
      if (stepId === undefined || stepToVisibility === undefined) {
        return true;
      }
      const isConditionMet = stepToVisibility[stepId];
      if (isConditionMet !== undefined) {
        return !isConditionMet;
      }
      // if the specific step's condition result is not found, default to visible
      return false;
    }

    // if `requireStepVisibilityCheck` is false, it means there is no RECORDLINK condition and a field can be shown/evaluated by other rules
    return false;
  }
}
